var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Popper, ClickAwayListener } from '@material-ui/core';
import React from 'react';
import { EmailShareButton, EmailIcon, FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, RedditShareButton, RedditIcon, TumblrShareButton, TumblrIcon, LinkedinIcon, LinkedinShareButton } from 'react-share';
import { FadeAnimation } from './utility';
import { shareLink } from '../manager';
var ShareModal = function (props) {
    var showModal = props.showModal;
    var onShowModalChange = props.onShowModalChange;
    var renderModal = function () {
        var _a, _b, _c, _d, _e, _f;
        var shareURL = props.shareURL;
        return (React.createElement("div", { className: "share-container" },
            React.createElement("div", { className: 'share-box' },
                React.createElement("div", { className: "share-row" },
                    React.createElement("div", { className: "share-item", onClick: function () { return onShowModalChange(false); }, style: { display: ((_a = props.remove) === null || _a === void 0 ? void 0 : _a.includes('facebook')) ? 'none' : '' } },
                        React.createElement(FacebookShareButton, { url: shareURL, quote: props.shareTitle, className: "share-item__share-button" },
                            React.createElement(FacebookIcon, { size: 50, round: true }),
                            React.createElement("div", null, "Facebook"))),
                    React.createElement("div", { className: "share-item", onClick: function () { return onShowModalChange(false); }, style: { display: ((_b = props.remove) === null || _b === void 0 ? void 0 : _b.includes('twitter')) ? 'none' : '' } },
                        React.createElement(TwitterShareButton, { url: shareURL, title: props.shareTitle, className: "share-item__share-button" },
                            React.createElement(TwitterIcon, { size: 50, round: true }),
                            React.createElement("div", null, "Twitter"))),
                    React.createElement("div", { className: "share-item", onClick: function () { return onShowModalChange(false); }, style: { display: ((_c = props.remove) === null || _c === void 0 ? void 0 : _c.includes('reddit')) ? 'none' : '' } },
                        React.createElement(RedditShareButton, { url: shareURL, title: props.shareTitle, windowWidth: 660, windowHeight: 460, className: "share-item__share-button" },
                            React.createElement(RedditIcon, { size: 50, round: true }),
                            React.createElement("div", null, "Reddit"))),
                    React.createElement("div", { className: "share-item", onClick: function () { return onShowModalChange(false); }, style: { display: ((_d = props.remove) === null || _d === void 0 ? void 0 : _d.includes('tumblr')) ? 'none' : '' } },
                        React.createElement(TumblrShareButton, { url: shareURL, title: props.shareTitle, className: "share-item__share-button" },
                            React.createElement(TumblrIcon, { size: 50, round: true }),
                            React.createElement("span", null, "Tumblr"))),
                    React.createElement("div", { className: "share-item", onClick: function () { return onShowModalChange(false); }, style: { display: ((_e = props.remove) === null || _e === void 0 ? void 0 : _e.includes('linkedin')) ? 'none' : '' } },
                        React.createElement(LinkedinShareButton, { url: shareURL, className: "share-item__share-button" },
                            React.createElement(LinkedinIcon, { size: 50, round: true }),
                            React.createElement("span", null, "LinkedIn"))),
                    React.createElement("div", { className: "share-item", onClick: function () { return onShowModalChange(false); }, style: { display: ((_f = props.remove) === null || _f === void 0 ? void 0 : _f.includes('email')) ? 'none' : '' } },
                        React.createElement(EmailShareButton, { url: shareURL, subject: props.shareTitle, className: "share-item__share-button" },
                            React.createElement(EmailIcon, { size: 50, round: true }),
                            React.createElement("div", null, "Email")))),
                React.createElement("div", { className: "share-input" },
                    React.createElement("input", { style: { width: '100%' }, type: "text", value: shareURL, contentEditable: false, readOnly: true }),
                    React.createElement("button", { className: "copy-button", onClick: function () {
                            shareLink(shareURL);
                            onShowModalChange(false);
                        } }, "COPY")))));
    };
    return (
    // <div className='share-anchor' ref={shareAnchor}>
    React.createElement(Popper, { anchorEl: props.shareAnchor, placement: 'bottom', open: showModal, modifiers: {
            flip: {
                enabled: true,
            },
            preventOverflow: {
                enabled: true,
                boundariesElement: 'window',
            }
        }, transition: true, style: { zIndex: 300, pointerEvents: showModal ? 'auto' : 'none' } }, function (transitionProps) {
        return React.createElement(FadeAnimation, __assign({}, transitionProps.TransitionProps),
            React.createElement(ClickAwayListener, { mouseEvent: showModal ? 'onClick' : false, onClickAway: function () {
                    onShowModalChange(false);
                } },
                React.createElement("div", { className: 'complex-dropddown ' + (showModal ? "slide-down" : "slide-up ") }, renderModal())));
    })
    // </div>
    );
};
export default ShareModal;
//# sourceMappingURL=ShareModal.js.map